
import { defineComponent, PropType } from "vue";
import {
  accountDisplayName,
  accountOptionKey,
  getPlatformMeta,
  normalizePlatform,
  PREVIEW_PLATFORM_ICONS,
  uniquePlatformsFromAccounts
} from "@/utils/socialPlatformMeta.js";
import {
  facebookPostTypeLabel,
  normalizeFacebookPostType,
  supportsFollowUpComment
} from "@/utils/socialPostPolicy.js";

export default defineComponent({
  name: "social-post-preview",
  props: {
    selectedAccounts: {
      type: Array as PropType<any[]>,
      default: () => []
    },
    caption: {
      type: String,
      default: ""
    },
    mediaUrls: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    linkUrl: {
      type: String,
      default: ""
    },
    followUpComment: {
      type: String,
      default: ""
    },
    facebookPostType: {
      type: String,
      default: "post"
    }
  },
  data() {
    return {
      activeTab: "all",
      previewIcons: PREVIEW_PLATFORM_ICONS
    };
  },
  computed: {
    hasSelectedAccounts(): boolean {
      return this.selectedAccounts.length > 0;
    },
    previewPlatforms(): string[] {
      return uniquePlatformsFromAccounts(this.selectedAccounts);
    },
    visibleAccounts(): any[] {
      if (this.activeTab === "all") return this.selectedAccounts;
      return this.selectedAccounts.filter(
        (account) => normalizePlatform(account.platform) === this.activeTab
      );
    },
    normalizedFacebookPostType(): string {
      return normalizeFacebookPostType(this.facebookPostType);
    }
  },
  watch: {
    previewPlatforms(platforms) {
      if (this.activeTab !== "all" && !platforms.includes(this.activeTab)) {
        this.activeTab = "all";
      }
    },
    selectedAccounts(accounts) {
      if (!accounts.length) this.activeTab = "all";
    }
  },
  methods: {
    getPlatformMeta,
    accountDisplayName,
    accountKey: accountOptionKey,
    isImageUrl(url: string) {
      return url.startsWith("blob:") || /\.(png|jpe?g|gif|webp|bmp|svg)(\?.*)?$/i.test(url);
    },
    facebookTypeBadge(account: any) {
      if (normalizePlatform(account.platform) !== "facebook") {
        return "";
      }
      return facebookPostTypeLabel(this.normalizedFacebookPostType);
    },
    isVerticalFacebookFormat(account: any) {
      return normalizePlatform(account.platform) === "facebook"
        && (this.normalizedFacebookPostType === "reel" || this.normalizedFacebookPostType === "story");
    },
    cardClass(account: any) {
      if (normalizePlatform(account.platform) !== "facebook") {
        return "";
      }
      return `social-post-preview__mock-card--${this.normalizedFacebookPostType}`;
    },
    showFollowUpComment(account: any) {
      return Boolean(this.followUpComment?.trim())
        && supportsFollowUpComment(account.platform);
    }
  }
});
